import { TableSettings } from "../models/TableSettings";

export const TableSettingsDefault: TableSettings = {
  pageSize: 5,
  ascending: false,
  orderBy: "",
};
